import OrderTable from "@/components/OrderTable";
import { useOrdersContext } from "@/contexts/orders-context";
import { useAppState } from "@/contexts/app-state";
import Loader from "@/components/Loader";
import { useOrders } from "@/hooks/use-orders";
import { useQueryKeys } from "@/hooks/use-query-keys";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";

const MyTasksContainer = () => {
  const { filters, sortOrder, sortBy } = useOrdersContext();
  const { loggedInUser } = useAppState();
  const {
    isPending,
    data = { total: 0, rows: [], tabData: [], totalPages: 0, totalCount: 0 },
  } = useOrders({
    user: loggedInUser,
    filters,
    sortBy,
    sortOrder,
  });
  const getQueryKey = useQueryKeys("orders");
  const navigate = useNavigate();

  useEffect(() => {
    if (data === null) {
      navigate(`/error`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  return (
    <Loader isLoading={isPending} displayText="Loading Your Tasks...">
      <OrderTable
        totalPages={data.totalPages}
        totalItems={data.totalCount}
        excludedColumns={["taoBucket", "assignedUser"]}
        rows={data.rows}
        tabs={data.tabData}
        ordersQueryKey={getQueryKey({ user: loggedInUser, filters })}
      />
    </Loader>
  );
};

export default MyTasksContainer;
